import { findTodoItems } from '@erikdakoda/todo/ai-tools/findTodoItems';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(findTodoItems);
